import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import CustomPaper from '../components/CustomPaper'
import SellerForm from '../components/SellerForm'
import SubmitFormDialog from '../components/SubmitFormDialog'
import { useNavigate } from 'react-router-dom'
import { Jeweler, JewelerInput } from '../utils/types'
import { useAlert } from '../hooks/useAlert'
import { getErrorMessage } from '../utils/errorHandler'
import { createJeweler, getJeweler, updateJeweler } from '../services/admin/AdminServices'

type SellerAddEditContainerProps = {
  id?: string
}

export default function SellerAddEditContainer({ id }: SellerAddEditContainerProps) {

  const [open, setOpen] = React.useState(false);
  const [isSuccessful, setIsSuccessful] = React.useState(false);
  const [title, setTitle] = React.useState('');
  const [content, setContent] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const nav = useNavigate();
  const { showSnackbar, showError } = useAlert();
  const [jeweler, setJeweler] = React.useState<Jeweler>();

  const handleSubmit = async (values: JewelerInput) => {
    try {
      if (id) {
        delete values.accountHolder;
        delete values.bankName;
        delete values.iban;
        delete values.identity;
        delete values.firstName;
        delete values.lastName;
        // enableBranches alanını koruyoruz
        const res = await updateJeweler(id, values);
        showSnackbar('Kuyumcu başarıyla güncellendi!', 'success');
        nav('/admin/jewelers');
      } else {
        const res = await createJeweler(values);
        setIsSuccessful(true);
        setTitle('Kuyumcu Başarıyla Eklendi!');
        setContent('Kuyumcu ekleme işleminiz başarılı olmuştur. Kullanıcıyı liste sayfasından kontrol edebilirsiniz.');
        setOpen(true);
      }
    } catch (e) {
      if (id) {
        showError(e, { defaultMessage: 'Bir hata oluştu. Lütfen tekrar deneyin.' });
      } else {
        setIsSuccessful(false);
        setTitle('Kuyumcu Eklenirken Bir Hata Oluştu!');
        setContent('Kuyumcu eklenirken bir hata oluştu. Lütfen tekrar deneyin.');
        setErrorMessage(getErrorMessage(e, { defaultMessage: '' }));
        setOpen(true);
      }
      console.log(e);
    }
  }

  const fetchJeweler = async (id: string) => {
    try {
      const res = await getJeweler(id);
      setJeweler(res);
      console.log(res);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (id) {
      fetchJeweler(id);
    }
  }, [id])

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '30px',
          fontWeight: 400,
        }}
      >
        {id ? 'Kuyumcu Düzenle' : 'Kuyumcu Ekle'}
      </Typography>
      <CustomPaper
        sx={{
          mt: 3
        }}
      >
        <SellerForm
          onSubmit={handleSubmit}
          initialValues={jeweler}
          isEdit={Boolean(id)}
        />
      </CustomPaper>
      <SubmitFormDialog
        open={open}
        title={title}
        content={content}
        onClose={() => isSuccessful ? nav('/admin/jewelers') : setOpen(false)}
        type={id ? 'edit' : 'add'}
        isSuccessful={isSuccessful}
        actionText1={isSuccessful ? 'Ana Sayfaya Dön' : 'Tekrar Dene'}
        actionText2='Listeyi Görüntüle'
        onAction1={() => isSuccessful ? nav('/') : setOpen(false)}
        onAction2={() => nav('/admin/jewelers')}
        errorMessage={errorMessage}
      />
    </Box>
  )
}
